const TOAST_LIFE = 7000;
const DEFAULT_ERROR_MESSAGE = 'Error en la petición, inténtelo de nuevo más tarde';

// type: 'success', 'info', 'warning', 'danger', 'loading'
const COMMON_TOAST_OPTIONS = {
  type: '',
  title: '',
  message: '',
  life: TOAST_LIFE,
  closable: true,
};
const ERROR_TOAST_OPTIONS = {
  ...COMMON_TOAST_OPTIONS,
  type: 'danger',
  title: 'Error',
  message: DEFAULT_ERROR_MESSAGE,
};
const WARNING_TOAST_OPTIONS = {
  ...COMMON_TOAST_OPTIONS,
  type: 'warning',
};
const SUCCESS_TOAST_OPTIONS = {
  ...COMMON_TOAST_OPTIONS,
  type: 'success',
};
const INFO_TOAST_OPTIONS = {
  ...COMMON_TOAST_OPTIONS,
  type: 'info',
};
export const errorToastOptions =
  (title = 'Error',
    message = DEFAULT_ERROR_MESSAGE) => {
    return {
      ...ERROR_TOAST_OPTIONS,
      title,
      message,
    };
  };
export const successToastOptions =
  (title, message) => {
    return {
      ...SUCCESS_TOAST_OPTIONS,
      title,
      message,
    };
  };
export const warningToastOptions =
  (title, message) => {
    return {
      ...WARNING_TOAST_OPTIONS,
      title,
      message,
    };
  };
export const infoToastOptions =
  (title, message) => {
    return {
      ...INFO_TOAST_OPTIONS,
      title,
      message,
    };
  };
